export default [
  '$state',
  'OrderService',
  'ErrorHandler',
  class TrackOrderController {
    constructor($state, orderService, errorHandler) {
      this._orderService = orderService;
      this._errorHandler = errorHandler;
      this._$state = $state;

      this.orderNumber = '';
      this.billingZip = '';
    }

    getOrderDetails(isValid) {
      if (isValid) {
        this.submitState = 'loading';
        this._orderService.getBaseOrder(`VS${this.orderNumber}`, this.billingZip)
          .then((res) => this.lookupSuccess(res))
          .catch((err) => this.lookupError(err));
      }
    }

    lookupSuccess(res) {
      this.submitState = 'success';

      this._$state.go('order-summary', {order: res});
    }

    lookupError(err) {
      let message = err && err.data && err.data.message ? err.data.message : 'Encountered an error while attempting to retrieve order.';
      this.submitState = 'error';
      this._errorHandler.throwError('Order Lookup Error', message, { orderNumber: this.orderNumber, billingZip: this.billingZip, rawError: err });
    }
    
    setOrderNumPrefix() {
      if(this.orderNumber.indexOf('VS') === -1) {
        this.orderNumber += 'VS';
      }
    }
  }
];



// WEBPACK FOOTER //
// ./source/client/pages/track-order/track-order.ctrl.js